<template>
  <c-box
    :title="'Динамика посещаемости сайта из посковых систем' + (data.length ? ' за ' + date.format('MMM') : '')"
    shadow
    header-divider
    :loading="loading"
  >
    <div id="tpw-g">
      <c-bar-chart
        v-if="!loading && data.length"
        :chart-data="chartData"
        :options="chartOptions"
        :height="200"
      />
    </div>
    <no-data v-if="!loading && !data.length" />
  </c-box>
</template>

<script>
import CBox from '../../../../../../../resources/js/components/ui/CBox.vue'
import moment from 'moment'
import NoData from '../../../../../../../resources/js/components/NoData.vue'
import CBarChart from '../../../../../../../resources/js/components/ui/CBarChart.vue'

export default {
  name: 'TrafficPerWeek',
  components: { CBarChart, NoData, CBox },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    data: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      chartOptions: {
        scales: {
          xAxes: [{
            gridLines: {
              display: false,
              drawBorder: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: 'Визиты'
            }
          }]
        },
        legend: {
          display: false
        },
        plugins: {
          datalabels: {
            anchor: 'end',
            align: 'top',
            font: {
              weight: 'bold'
            }
          }
        }
      }
    }
  },
  computed: {
    date () {
      return this.data.length ? moment(this.data[0].ДатаОкончания) : moment()
    },
    chartData () {
      return {
        labels: this.data.map(i => moment(i.ДатаНачала).format('D MMM') + ' - ' + moment(i.ДатаОкончания).format('D MMM')),
        datasets: [
          {
            data: this.data.map(i => i.КоличествоВизитов),
            fill: false,
            backgroundColor: '#ffb137',
            lineTension: 0
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  #tpw-g {
    min-width: 478px;
  }
</style>
